import { BaseTextFieldProps, InputBaseProps } from "@material-ui/core"
import { Field } from "formik"
import { TextField } from "formik-material-ui"
import styled from "styled-components"

const Styled = {
  Field: styled(Field)<{ $center?: boolean }>`
    width: 100%;
    .MuiFormHelperText-root {
      font-size: 18px;
      font-family: Speedee, NarkisBlock-Thin, sans-serif;
    }
    .MuiFormHelperText-root.Mui-error {
      ${(p) => (p.$center ? `text-align: center;` : ``)};
      color: #d70202;
    }
    input {
      ${(p) => (p.$center ? `text-align: center;` : ``)}
    }
  `,
}

export interface CommonInputProps extends BaseTextFieldProps {
  name: string
  label?: string
  type?: "text" | "email" | "tel" | "number" | "date"
  required?: boolean
  maxLength?: number
  placeholder?: string
  numeric?: boolean
  InputProps?: InputBaseProps
  centerField?: boolean
  autoFocus?: boolean
}
// todo the error messageis not working!
const FormikInput = ({
  name,
  label,
  type = "text",
  required = false,
  placeholder,
  maxLength,
  numeric,
  InputProps,
  centerField,
  autoFocus,
  ...props
}: CommonInputProps) => {
  return (
    <Styled.Field
      $center={centerField}
      label={label}
      component={TextField}
      id={name}
      name={name}
      type={type}
      required={required}
      helperText={" "}
      placeholder={placeholder}
      inputProps={{
        maxLength: maxLength,
        inputMode: numeric && "numeric",
        pattern: numeric && "[0-9]*",
        style: { direction: type === "tel" ? "rtl" : undefined },
      }}
      InputProps={{
        ...InputProps,
      }}
      autoFocus={autoFocus}
      variant="outlined"
      {...props}
    />
  )
}

export default FormikInput
